module.exports = __webpack_public_path__ + "static/media/energy.7fba0160.svg";